// Halloween 2026 en Let's Move (Carlos 2-oct): a diferencia de la agenda, aquí se enciende SIN
// preguntar (index.html pone html.lm-halloween hasta el 2-nov-2026). Este botón, junto al de
// tema, lo quita o lo vuelve a poner; la elección se guarda por navegador y se registra en
// /api/ui-choices (misma tabla que la agenda) para saber cuántos lo apagaron.
import { useState } from 'react';

const HASTA = new Date(2026, 10, 2);
const KEY = 'lm-halloween-2026';

const Pumpkin = ({ size }: { size: number }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <path d="M32 14c-2-6 2-9 6-10" stroke="#3F6212" strokeWidth="4" fill="none" strokeLinecap="round" />
    <ellipse cx="20" cy="38" rx="14" ry="20" fill="#EA7A1F" />
    <ellipse cx="44" cy="38" rx="14" ry="20" fill="#EA7A1F" />
    <ellipse cx="32" cy="38" rx="13" ry="21" fill="#F59231" />
    <path d="M22 34l5-5 5 5zM36 34l5-5 5 5z" fill="#3B1D06" />
    <path d="M21 44q11 9 22 0l-4 2-3-3-3 4-3-4-3 3z" fill="#3B1D06" />
  </svg>
);

export default function HalloweenToggle() {
  const [on, setOn] = useState(() => document.documentElement.classList.contains('lm-halloween'));
  if (new Date() >= HASTA) return null;
  const flip = () => {
    const v = !on;
    document.documentElement.classList.toggle('lm-halloween', v);
    try { localStorage.setItem(KEY, v ? 'on' : 'off'); } catch { /* solo esta carga */ }
    setOn(v);
    fetch('/api/ui-choices', {
      method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ key: 'halloween-2026', value: v ? 'on' : 'off' }),
    }).catch(() => {});
  };
  const label = on ? 'Quitar Halloween' : 'Poner Halloween';
  return (
    <button
      onClick={flip}
      title={label}
      aria-label={label}
      aria-pressed={on}
      data-testid="lm-halloween-toggle"
      className={`flex h-9 w-9 items-center justify-center rounded-lg ring-1 transition hover:bg-surface-2 ${on ? 'ring-accent/60' : 'ring-line opacity-60 grayscale'}`}
    >
      <Pumpkin size={20} />
    </button>
  );
}
